import { render, staticRenderFns } from "./AdminDialog.vue?vue&type=template&id=458cd144&scoped=true&"
import script from "./AdminDialog.vue?vue&type=script&lang=js&"
export * from "./AdminDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458cd144",
  null
  
)

export default component.exports